import createCachedSelector from 're-reselect'

import { CobaltPath } from 'routing/Path'
import { List, RootReduxState } from 'types'

import { selectDomainValue, createPathCacheKey } from './ui'

export const selectListSettings = createCachedSelector<
    RootReduxState,
    CobaltPath,
    List<any>,
    List<any>['listSettings']
>(
    (state, listPath) => selectDomainValue(state, listPath),
    (list) => list.listSettings
)((_state, listPath) => createPathCacheKey(listPath))
